import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../utils/axiosInstance";
import GlobalError from "../components/GlobalError";
import TableView from "../components/TableView";
import DefinitionRow from "../components/DefinitionRow";
import SupplierModal from "../components/SupplierModal";
import SupplierContactModal from "../components/SupplierContactModal";
import SupplierProductModal from "../components/SupplierProductModal";
import { Paper, Typography, Button, Chip, Stack, IconButton, Box, Link } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { formatCurrency } from "../utils/format";
const SupplierDetailPage = ({ hasLimit }) => {
    const navigate = useNavigate();
    const { supplierId } = useParams();
    const [supplier, setSupplier] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [products, setProducts] = useState([]);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [openContactModal, setOpenContactModal] = useState({ open: false, contact: null });
    const [openProductModal, setOpenProductModal] = useState({ open: false, product: null });

    const load = async () => {

        try {
            const res = await axiosInstance.get(
                `/supplier/${supplierId}`
            );
            setSupplier(res.data.supplier);
            setContacts(res.data.contacts);
            setProducts(res.data.products);

        } catch (err) {
            setError("データ取得に失敗しました");
        }
    };

    useEffect(() => {
        load();
    }, [supplierId]);

    const sortedContacts = [...contacts].sort(
        (a, b) => Number(b.is_primary) - Number(a.is_primary)
    );
    if (error) return <GlobalError errorMessage={error} />;
    if (!supplier) return null;

    const columns_contact = [
        {
            label: "担当者名前",
            accessor: "name",
            width: "150px"
        },
        {
            label: "メールアドレス",
            accessor: "email",
            width: "300px"
        },
        {
            label: "電話番号",
            accessor: "phone",
            width: "150px"
        },
        {
            label: "役割",
            accessor: "role",
            width: "150px"
        },
        {
            label: "メイン",
            width: "120px",
            render: (row) =>
                row.is_primary ? (
                    <Chip label="メイン" size="small" color="primary" />
                ) : null
        },
        {
            label: "ステータス",
            width: "140px",
            render: (row) => {
                const map = {
                    active: { label: "有効", color: "success" },
                    pending: { label: "保留", color: "warning" },
                    invalid: { label: "無効", color: "default" }
                };

                const s = map[row.status];

                return s ? (
                    <Chip label={s.label} size="small" color={s.color} />
                ) : null;
            }
        },
        {
            label: "",
            width: "60px",
            render: (row) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setOpenContactModal({ open: true, contact: row })}
                >
                    編集
                </Button>
            )
        }
    ];
    const columns_product = [
        {
            label: "品番",
            accessor: "sku",
            render: (item) => (
                <Link
                    onClick={() => navigate(`/products/${item.product_id}`)}>
                    {item.sku}
                </Link>
            ),
            width: "150px"
        },
        {
            label: "商品名",
            accessor: "product_name",
            render: (item) => (
                <Box sx={{ maxWidth: 400 }}>
                    <Typography>{item.product_name}</Typography>
                    <Typography variant='caption' color='text.secondary'>
                        {item?.option_combination &&
                            Object.entries(item.option_combination).map(([type, value]) => (
                                <React.Fragment key={type}>
                                    {" "}
                                    {type}: {value}
                                </React.Fragment>
                            ))}
                    </Typography>
                </Box>
            )
        },
        {
            label: "仕入価格",
            accessor: "purchase_price",
            render: (item) => (
                <Typography>{formatCurrency(item.purchase_price)}</Typography>
            ),
            width: "150px"
        },
        /*{
            label: "メイン",
            width: "120px",
            render: (row) =>
                row.is_primary ? (
                    <Chip label="メイン" size="small" color="primary" />
                ) : null
        },*/
        {
            label: "ステータス",
            width: "140px",
            render: (row) => {
                const map = {
                    active: { label: "有効", color: "success" },
                    pending: { label: "保留", color: "warning" },
                    invalid: { label: "無効", color: "default" }
                };

                const s = map[row.status];

                return s ? (
                    <Chip label={s.label} size="small" color={s.color} />
                ) : null;
            }
        },
        {
            label: "",
            width: "60px",
            render: (row) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setOpenProductModal({ open: true, product: row })}

                >
                    編集
                </Button>
            )
        }
    ];
    return (
        <>
            <Typography variant="h1">
                仕入れ先詳細
            </Typography>

            {/* 基本情報 */}
            <Paper variant="section">

                <DefinitionRow label="仕入先コード">
                    <Typography>{supplier.supplier_code}</Typography>
                </DefinitionRow>

                <DefinitionRow label="企業名">
                    <Typography>{supplier.supplier_name}</Typography>
                </DefinitionRow>

                <DefinitionRow label="住所">
                    <Typography>〒{supplier.postal_code} {supplier.state} {supplier.address_line}</Typography>
                </DefinitionRow>
                <DefinitionRow label="電話番号">
                    <Typography>{supplier.supplier_phone}</Typography>
                </DefinitionRow>
                <DefinitionRow label="締め日">
                    <Typography>{supplier.closing_day}</Typography>
                </DefinitionRow>

                <DefinitionRow label="支払日">
                    <Typography>{supplier.payment_day}</Typography>
                </DefinitionRow>
                <DefinitionRow label="ステータス">
                    {(() => {
                        const map = {
                            active: { label: "有効", color: "success" },
                            pending: { label: "保留", color: "warning" },
                            invalid: { label: "無効", color: "default" }
                        };
                        const s = map[supplier.status];

                        return s ? (
                            <Chip label={s.label} size="small" color={s.color} />
                        ) : (
                            "-"
                        );
                    })()}
                </DefinitionRow>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Edit />}
                    onClick={() => setOpen(true)}
                    sx={{ mt: 1 }}
                >
                    編集
                </Button>
            </Paper>
            <SupplierModal
                open={open}
                onClose={() => setOpen(false)}
                supplier={supplier}
                onSaved={(updated) => setSupplier(updated)}
            />

            <Paper variant="section">
                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        担当者
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ mb: 1 }}
                        onClick={() => setOpenContactModal({ open: true })}
                    >
                        担当者を追加
                    </Button>
                </Stack>
                <TableView
                    dataset={sortedContacts || []}
                    columns={columns_contact}
                    keyColumn="supplier_contact_id"
                />
            </Paper>
            <Paper variant="section">
                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        取扱い商品
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ mb: 1 }}
                        onClick={() => setOpenProductModal({ open: true })}
                    >
                        商品を追加
                    </Button>
                </Stack>
                <TableView
                    dataset={products || []}
                    columns={columns_product}
                    keyColumn="variant_id"
                />
            </Paper>
            <SupplierContactModal
                open={openContactModal.open}
                contact={openContactModal.contact}
                supplierId={supplierId}
                onClose={() => setOpenContactModal({ open: false, contact: null })}
                onSaved={async () => {
                    setOpenContactModal({ open: false, contact: null });
                    await load();
                }}
                onDeleted={async () => {
                    setOpenContactModal({ open: false, contact: null });
                    await load();
                }}
            />
            <SupplierProductModal
                hasLimit={hasLimit}
                open={openProductModal.open}
                product={openProductModal.product}
                supplierId={supplierId}
                onClose={() => setOpenProductModal({ open: false, product: null })}
                onSaved={async () => {
                    setOpenProductModal({ open: false, product: null });
                    await load();
                }}
                onDeleted={async () => {
                    setOpenProductModal({ open: false, product: null });
                    await load();
                }}
            />
        </>
    );
};

export default SupplierDetailPage;